import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../core/services/navigation/navigation.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { SellerState, selectsellerState } from 'src/store/reducers';
import { constants } from 'src/appconstant';
import { SellerService } from './seller.service';
@Component({
  selector: 'app-seller',
  templateUrl: './seller.component.html',
  styleUrls: ['./seller.component.scss']
})
export class SellerComponent implements OnInit {
  seller;
  getState: Observable<any>;
  constructor(
    private store: Store<SellerState>, private sellerService: SellerService,
    private navigation: NavigationService
  ) {
    this.getState = this.store.select(selectsellerState);

  }

  ngOnInit() {
/* 
    this.seller = [
      {"cities":["Helsinki"],"id":26,"title":"test","image":null,"details":"test41","category_id":5,"price":9,"price_unit":"hectare","user_id":3,"status":"active","expiry_date":"2019-01-22T10:56:22.000Z","weight":2,"type":"sell","weight_unit":"kilogram","more_information":null,"created_at":"2019-01-16T07:30:25.000Z","updated_at":"2019-01-22T08:52:11.000Z","addresses":[{"id":63,"user_id":3,"address":"55","zip_code":12345,"city":"test","country":null,"primary_address":false,"latitude":24.8762,"longitude":67.0233,"type":10,"name":null,"announcement_id":26,"time":null,"createdAt":"2019-01-21T10:01:08.000Z","updatedAt":"2019-01-22T08:52:11.000Z"},
      {"id":65,"user_id":3,"address":"56","zip_code":12345,"city":"test","country":null,"primary_address":false,"latitude":null,"longitude":null,"type":10,"name":null,"announcement_id":26,"time":null,"createdAt":"2019-01-21T10:42:27.000Z","updatedAt":"2019-01-22T08:52:11.000Z"}]},{"cities":["Helsinki"],"id":99,"title":"test","image":null,"details":"test41","category_id":5,"price":9,"price_unit":"hectare","user_id":3,"status":"active","expiry_date":"2019-01-22T12:30:00.000Z","weight":2,"type":"sell","weight_unit":"kilogram","more_information":null,"created_at":"2019-01-21T07:01:10.000Z","updated_at":"2019-01-21T12:21:45.000Z","addresses":[]},
      {"cities":["Helsinki"],"id":125,"title":"test","image":null,"details":"test41","category_id":5,"price":9,"price_unit":"hectare","user_id":3,"status":"active","expiry_date":"2019-01-22T12:30:00.000Z","weight":2,"type":"sell","weight_unit":"kilogram","more_information":null,"created_at":"2019-01-21T11:27:30.000Z","updated_at":"2019-01-21T11:27:30.000Z","addresses":[]},{"cities":["Helsinki"],"id":72,"title":"test","image":null,"details":"test41","category_id":5,"price":9,"price_unit":"hectare","user_id":3,"status":"active","expiry_date":"2019-01-22T12:30:00.000Z","weight":2,"type":"sell","weight_unit":"kilogram","more_information":null,"created_at":"2019-01-16T12:16:50.000Z","updated_at":"2019-01-21T06:38:03.000Z","addresses":[]},
      {"image_url":"announcements/3/BeIw--p7A2oJmAwr3fJkQ7xQ.png","cities":["Helsinki"],"id":73,"title":"cartoon","image":"BeIw--p7A2oJmAwr3fJkQ7xQ.png","details":"new test announcement","category_id":5,"price":9,"price_unit":"hectare","user_id":3,"status":"active","expiry_date":"2019-01-30T12:30:00.000Z","weight":2,"type":"sell","weight_unit":"kilogram","more_information":null,"created_at":"2019-01-16T13:47:22.000Z","updated_at":"2019-01-18T11:27:19.000Z","addresses":[{"id":52,"user_id":3,"address":"9909","zip_code":12345,"city":"abcdefg","country":null,"primary_address":false,"latitude":null,"longitude":null,"type":10,"name":null,"announcement_id":73,"time":null,"createdAt":"2019-01-18T11:20:53.000Z","updatedAt":"2019-01-18T11:20:53.000Z"},
      {"id":53,"user_id":3,"address":"9909","zip_code":12345,"city":"xyz","country":null,"primary_address":false,"latitude":null,"longitude":null,"type":10,"name":null,"announcement_id":73,"time":null,"createdAt":"2019-01-18T11:20:53.000Z","updatedAt":"2019-01-18T11:20:53.000Z"}]}];
 */
    this.getState.subscribe((state) => {
       if (state.seller) {
         this.seller = state.seller.rows;
       }
     });
     this.sellerService.dispatchSellerAction();
  }

  retrieveImage(image) {
    return (image === '' || image === undefined) && "../../../assets/images/noImageFound.jpg" || constants.AWS_URL + image;
  }
  getComma(length, index) {
    return (length === index) && '' || ',';
  }
  viewall(route, buyrSellr)
  {
    this.navigation.navigateTo(route, '', buyrSellr);
  }
  routeTo(path,id){
    if(localStorage.getItem("token")){
      this.navigation.navigateTo([`${path}/${id}`]);
      }
      else{
        this.navigation.navigateTo('login');
      }
  }
}
